import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INotificationSnackbarState } from '../../types/store';

const initialState: INotificationSnackbarState = {
  isOpen: false,
  message: '',
  severity: 'info',
};

const notificationSnackbarSlice = createSlice({
  name: 'notificationSnackbarSlice',
  initialState,
  reducers: {
    showNotification: (
      state,
      action: PayloadAction<{ message: string; severity?: INotificationSnackbarState['severity'] }>,
    ) => {
      state.message = action.payload.message;
      state.severity = action.payload.severity ?? 'info';
      state.isOpen = true;
    },
    hideNotification: (state) => {
      state.isOpen = initialState.isOpen;
      state.message = initialState.message;
      state.severity = initialState.severity;
    },
  },
});

export const { showNotification, hideNotification } = notificationSnackbarSlice.actions;

export default notificationSnackbarSlice.reducer;
